// Material Kit 2 React pages
import Cources from "pages/LandingPages/Cources";

export default function CourcesPage() {
  return <Cources />;
}
